import React from "react";
import "./wallet-withdrawal-summary-modal.scss";
import AlertModal from "../Modal";
import OtpInput from "react-otp-input";
import PrimaryTheme from "../../Themes/Primary";
import WithdrawalAuthentication from "../withdrawalAuthentication";
import StatusAlert from "../StatusAlert";
import { useDispatch, useSelector } from "react-redux";
import { Reducers } from "../../Interfaces/Interfaces";
import { useHistory } from "react-router-dom";
import { getCurrency, requestIdGenerator } from "../../helpers/Functions";
import { verifyUserOtp, withdrawalFromWalletToOtherBank, withdrawFromCommissionToWallet, withdrawToBank } from "../../redux/actions/userActions";

const WalletWithdrawalSummaryModal = (props: any) => {

  const verifyOtp = useSelector((state: Reducers) => state.verifyOtp);
  const alert = useSelector((state: Reducers) => state.alert);
  const cashout = useSelector((state: Reducers) => state.cashout);
  const dashboard = useSelector((state: Reducers) => state.dashboard);
  const user = useSelector((state: Reducers) => state.user);

  const dispatch = useDispatch();
  const history = useHistory();

  const closeModal = () => {
    props.setLoading(false);
    props.setIsSummary(false)
    props.setPin("");
    props.setAmount("");
    dispatch({ type: "ALERT_MODAL", payload: false });
  };

  const handleCommissionCashouts= (e:any)=> {
    e.preventDefault();

    const data = {
      accountName: user.businessName,
      accountNumber: dashboard.wallet.nuban,
      bankCode: 34,
      bankName: dashboard.wallet.bankName,
      amountToSend: props.amount,
      phoneNumber: user.phoneNumber,
      pin: props.pin,
      clientRequestId: requestIdGenerator(),
      channel: "1",
    };
    props.setLoadingCommissionCashout(true)
    
    dispatch(withdrawFromCommissionToWallet(data));
  }

  const handleOtpSubmit = () => {
    props.setSubmittedOtp(true);
    const data = {
        validatedEntityId: props.validatedEntityId,
        otp: props.authenticationOtp,
    };
    dispatch(verifyUserOtp(data));
  };
  

  React.useEffect(() => {    
    if(props.withdrawalType=='Wallet') {
      if (verifyOtp && Object.entries(verifyOtp).length !== 0) {
        if (verifyOtp.message == "OTP verified successfully") {          
          const data = {
            accountName: cashout.accountName,
            accountNumber: cashout.accountNumber,
            bankCode: cashout.bankCode,
            bankName: cashout.bankName,
            amountToSend: props.amount,
            phoneNumber: cashout.phoneNumber,
            walletSource: "1",
            otp: props.authenticationOtp,
            clientRequestId: requestIdGenerator(),
            channel: "1",
            pin: props.pin
            
          };          
          dispatch(withdrawalFromWalletToOtherBank(data));
            
        }
      }
    }
  }, [verifyOtp, dispatch]);

  
  
  return (
    <AlertModal showClose maxWidth="xs" title="Summary" blueCloseBtn>
      <div>
        {!props.authenticate ?
          <div className="modal-dialog" role="document">
            <div className="modal-content">
              <div className="modal-body">
                <div className="wallet-modal-body-upper-part">
                  {props.withdrawalType=='Wallet'?
                    <div>
                      <div className="d-flex justify-content-between align-items-center col-12 p-0 mb-3">
                        <label className="mb-0">Bank name</label>
                        <div className="modal-info">{cashout.bankName}</div>
                      </div>
                      <div className="d-flex justify-content-between align-items-center col-12 p-0 mb-3">
                        <label className="mb-0">Receiver</label>
                        <div className="modal-info">{cashout.accountName}</div>
                      </div>
                      <div className="d-flex justify-content-between align-items-center col-12 p-0 mb-3">
                        <label className="mb-0">Account NO</label>
                        <div className="modal-info">{cashout.accountNumber}</div>
                      </div>
                      <div className="d-flex justify-content-between align-items-center col-12 p-0 mb-3">
                        <label className="mb-0">Amount</label>
                        <div className="modal-info">{getCurrency(props.amount)}</div>
                      </div>
                      <div className="d-flex justify-content-between align-items-center col-12 p-0">
                        <label className="mb-0">Transfer fee</label>
                        <div className="modal-info">₦25.00</div>
                      </div>
                      <hr />
                    </div>:
                    <div className="">
                      <div className="d-flex align-items-center col-12 p-0 mb-3">
                        <span className="pin-text mb-0">Enter transaction PIN to confirm commissions withdrawal of {getCurrency(props.amount)} to Wallet</span>
                      </div>
                    </div>}
                </div>
                <div className="otp-input-wrapper">
                  {props.withdrawalType=='Wallet'&&
                    <div className="title">Enter your transaction PIN</div>
                  }
                  <div className="row m-0 justify-content-center align-items-center">
                    <OtpInput
                      value={props.pin}
                      onChange={(e: any) => props.setPin(e)}
                      numInputs={4}
                      isInputNum
                      shouldAutoFocus
                      inputStyle={{
                        width: "45px",
                        height: "45px",
                        fontSize: "24px",
                        padding: 0,
                        textAlign: "center",
                        borderRadius: 10,
                        border: "1px solid",
                        borderColor: PrimaryTheme.primary,
                      }}
                      isInputSecure
                      separator={<span className="mr-3"> </span>}
                    />
                  </div>
                </div>
                <button 
                  onClick={props.withdrawalType=='Commission'?handleCommissionCashouts:props.handleBank} 
                  className="col-12"
                  disabled={props.pin.length === 0}
                >
                  {props.loadingCommissionCashout ? "Please wait..." : "Continue"}
                </button>
              </div>
            </div>
          </div>:
          <WithdrawalAuthentication
            otp={props.authenticationOtp}
            setOtp={props.setAuthenticationOtp}
            handleSubmit={handleOtpSubmit}
            account={props.account}
            setAmount={props.setAmount}
            submitted={props.submittedOtp}
            title={props.title}
            subtitle={props.subtitle}
            handleRefresh={props.handleRefresh}
            counter={props.counter}
            setCounter={props.setCounter}
            handleBank={props.handleBank}
            setAuthenticate={props.setAuthenticate}
            setLoadingCommissionCashout={props.setLoadingCommissionCashout}
            setIsSummary={props.setIsSummary}
          />
        }
        <StatusAlert
          title={props.title}
          subtitle={props.subtitle}
          buttonTitle={"Close"}
          onClick={props.handleRefresh}
        ></StatusAlert>

      </div>
    </AlertModal>
    
  );
};

export default WalletWithdrawalSummaryModal;

